import { Grid, InputLabel, Select, Button, FormControl, Switch, MenuItem, TextField, FormControlLabel } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { Form as FormikForm, useFormikContext } from "formik";

import { CustomField } from '../../../inputs/CustomField';

export const CreateOrganizationForm = ({ onClose }) => {

    const {isSubmitting, values, setFieldValue } = useFormikContext();

    return (
        <FormikForm>
            <Grid container spacing={2} >

                <Grid item xs={12}>
                <CustomField name="description" label="Nombre del concurso" as={TextField} fullWidth />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={values.blockRegistrations || false}
                                onChange={(e) => setFieldValue('blockRegistrations', e.target.checked)}
                            />
                        }
                        label="Bloquear inscripciones"
                    />
                </Grid>

            </Grid>

            <Grid item sm={12} textAlign={"right"} mt={3}>

                <Button
                    variant="outlined"
                    onClick={() => onClose()}
                >
                    cancelar
                </Button>

                <Button sx={{ marginLeft: 2 }}
                    variant="contained"
                    type="submit"
                >
                    {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} />}
                    {isSubmitting ? 'Guardando' : 'Guardar'}
                </Button>

            </Grid>

        </FormikForm>
    );
}

export default CreateOrganizationForm;